import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._m(0)])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Modelo",
      "label-for": "modelo"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.form.modelo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "modelo", $$v);
      },
      expression: "form.modelo"
    }
  }, _vm._l(_vm.modelos, function (m, index) {
    return _c('b-form-select-option', {
      key: 'modelo' + index,
      attrs: {
        "value": m.id
      }
    }, [_vm._v(" " + _vm._s(m.descricao) + " ")]);
  }), 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "proximaNota",
      "label-for": "proximaNota",
      "label": "N° do próximo documento fiscal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "maxlength": "9",
      "state": _vm.validateState('proximaNota'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.proximaNota.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.proximaNota, "$model", $$v);
      },
      expression: "$v.form.proximaNota.$model"
    }
  })], 1)], 1)], 1)], 1), _c('b-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.modelo == 65,
      expression: "form.modelo == 65"
    }],
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "proximaVenda",
      "label-for": "proximaVenda",
      "label": "N° da próxima Pré-Venda"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "maxlength": "9"
    },
    model: {
      value: _vm.form.proximaVenda,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "proximaVenda", $$v);
      },
      expression: "form.proximaVenda"
    }
  })], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "serie",
      "label-for": "serie",
      "label": "Série do documento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('serie')
    },
    model: {
      value: _vm.$v.form.serie.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.serie, "$model", $$v);
      },
      expression: "$v.form.serie.$model"
    }
  })], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ambiente",
      "label-for": "ambiente"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "",
      "state": _vm.validateState('ambiente')
    },
    on: {
      "change": _vm.setSerie
    },
    model: {
      value: _vm.$v.form.ambiente.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.ambiente, "$model", $$v);
      },
      expression: "$v.form.ambiente.$model"
    }
  }, _vm._l(_vm.ambientes, function (a, index) {
    return _c('b-form-select-option', {
      key: 'ambiente' + index,
      attrs: {
        "value": a.id
      }
    }, [_vm._v(" " + _vm._s(a.descricao) + " ")]);
  }), 1)], 1)], 1)], 1), _c('b-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.modelo == 65,
      expression: "form.modelo == 65"
    }]
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "idTokenCSC",
      "label-for": "idTokenCSC",
      "label": "ID Token CSC"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "000000",
      "maxlength": "6"
    },
    model: {
      value: _vm.form.idTokenCSC,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "idTokenCSC", $$v);
      },
      expression: "form.idTokenCSC"
    }
  })], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tokenCSC",
      "label-for": "tokenCSC",
      "label": "Token SC"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50",
      "placeholder": "A321BCDE-1234-5678"
    },
    model: {
      value: _vm.form.tokenCSC,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tokenCSC", $$v);
      },
      expression: "form.tokenCSC"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.modelo == 65,
      expression: "form.modelo == 65"
    }]
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "informacoesComplementares",
      "label": "Informações Complementares",
      "label-for": "informacoesComplementares"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "6",
      "max-rows": "6",
      "id": "informacoesComplementares",
      "name": "informacoesComplementares"
    },
    model: {
      value: _vm.form.informacoesComplementares,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "informacoesComplementares", $$v);
      },
      expression: "form.informacoesComplementares"
    }
  })], 1)], 1)], 1), _c('b-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.modelo == 58,
      expression: "form.modelo == 58"
    }]
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo MDFe",
      "label-for": "tipo_transportador"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tipo_transportador,
      expression: "form.tipo_transportador"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipo_transportador",
      "id": "tipo_transportador"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "tipo_transportador", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.tiposMDFe, function (u, index) {
    return _c('option', {
      key: 'tipo_transportador' + index,
      domProps: {
        "value": u.id
      }
    }, [_vm._v(" " + _vm._s(u.descricao) + " ")]);
  }), 0)])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "rntrc",
      "label-for": "rntrc",
      "label": "RNTRC"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "20"
    },
    model: {
      value: _vm.form.rntrc,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rntrc", $$v);
      },
      expression: "form.rntrc"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('b-col', [_c('b-row', [_c('b-form-group', {
    attrs: {
      "id": "ativo",
      "label-for": "ativo",
      "label": "Ativo"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.ativo == true
    },
    on: {
      "change": _vm.setAtivo
    }
  }), _c('span')])])]), _c('b-row', [_c('b-form-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.modelo == 55,
      expression: "form.modelo == 55"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "id": "contigenciaSVCAN",
      "label-for": "solicitarDadosCartao",
      "label": "SVCAN (SEFAZ Virtual de Contingência Ambiente Nacional)"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.contigenciaSVCAN == true
    },
    on: {
      "change": _vm.setContigenciaSVCAN
    }
  }), _c('span')])])]), _c('b-form-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.modelo == 65,
      expression: "form.modelo == 65"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "solicitarDadosCartao",
      "label-for": "solicitarDadosCartao",
      "label": "Solicitar dados da transação ao finalizar venda Crédito/Débito?"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.solicitarDadosCartao == true
    },
    on: {
      "change": _vm.setDadosCartao
    }
  }), _c('span')])])]), _c('b-form-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.modelo == 65,
      expression: "form.modelo == 65"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "padraoPdvWeb",
      "label-for": "padraoPdvWeb",
      "label": "Usar como padrão do PDV Web"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.padrao_pdv_web == true
    },
    on: {
      "change": _vm.setPadraoPdvWeb
    }
  }), _c('span')])]), _c('small', {
    staticClass: "form-text text-muted mt-2"
  }, [_vm._v(" Somente uma configuração NFC-e pode ser padrão do PDV Web. Ao marcar esta opção, as outras serão desmarcadas automaticamente. ")])])], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_configuracao",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'configuracoesLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    }
  }, [_vm._v(" Cadastro ")])]);
}];
export { render, staticRenderFns };